/**
 * TTJ FAQ — accordion interaction.
 *
 * Works across all 5 FAQ designs since they share the same markup:
 *   [data-ttj-faq] > [data-ttj-faq-item] > button.ttj-faq__question + .ttj-faq__answer
 *
 * data-single-open="true" (Accordion — Single Open) closes any other open
 * item when one is opened. Every other design allows multiple open items.
 *
 * Buttons are native <button> elements, so Enter/Space activation and Tab
 * focus order are handled by the browser with no extra keyboard code.
 */
(function () {
  'use strict';

  function openItem(item) {
    var btn = item.querySelector('.ttj-faq__question');
    var panel = item.querySelector('.ttj-faq__answer');
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    item.classList.add('ttj-faq__item--open');
  }

  function closeItem(item) {
    var btn = item.querySelector('.ttj-faq__question');
    var panel = item.querySelector('.ttj-faq__answer');
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    item.classList.remove('ttj-faq__item--open');
  }

  function initFaq(root) {
    if (!root || root.dataset.ttjFaqBound === 'true') return;
    root.dataset.ttjFaqBound = 'true';

    var singleOpen = root.dataset.singleOpen === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ttj-faq-item]'));

    items.forEach(function (item) {
      var btn = item.querySelector('.ttj-faq__question');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (singleOpen && !isOpen) {
          items.forEach(function (otherItem) {
            if (otherItem !== item) closeItem(otherItem);
          });
        }

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ttj-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-bind when the section is reloaded inside the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ttj-faq]');
    if (root) {
      root.dataset.ttjFaqBound = '';
      initFaq(root);
    }
  });
})();
